module.exports = __webpack_public_path__ + "img/peritos_banner_gr.8e8118fa.jpg";